import React from 'react';
import useReveal from '../hooks/use-reveal';

const JasonSection = () => {
  const head = useReveal();
  const body = useReveal();

  return (
    <section
      data-testid="jason-section"
      style={{ padding: '100px 24px', maxWidth: '900px', margin: '0 auto' }}
    >
      <div ref={head.ref} className={`reveal ${head.visible ? 'visible' : ''}`}>
        <div className="yup-eyebrow" style={{ marginBottom: '20px' }}>
          Who this is from
        </div>
        <h2 className="yup-section-title" style={{ marginBottom: '24px' }}>
          This came from<br />
          <em>the inside out.</em>
        </h2>
      </div>

      <div
        ref={body.ref}
        className={`reveal ${body.visible ? 'visible' : ''}`}
        style={{ maxWidth: '640px', marginTop: '32px' }}
      >
        <p style={{ color: 'var(--yup-muted)', fontSize: '16px', lineHeight: 1.8, marginBottom: '20px' }}>
          I didn't build this from a seminar or a certification. I built it from thirty
          years of living, running, breaking down and slowly putting myself back together.
        </p>
        <p style={{ color: 'var(--yup-muted)', fontSize: '16px', lineHeight: 1.8, marginBottom: '20px' }}>
          I spent over twenty years jumping from one thing to the next — relationships,
          businesses, identities — without ever stopping to look at what was actually
          driving it. When my marriage ended and I became a single dad, I couldn't run
          anymore.{' '}
          <strong style={{ color: 'var(--yup-ink)', fontWeight: 500 }}>
            For the first time in my life I had to stay and face it.
          </strong>
        </p>

        <div
          className="font-serif"
          style={{
            fontSize: 'clamp(20px, 3vw, 28px)',
            fontWeight: 300,
            fontStyle: 'italic',
            color: 'var(--yup-ink)',
            lineHeight: 1.4,
            borderLeft: '2px solid var(--yup-warm)',
            paddingLeft: '24px',
            margin: '32px 0',
          }}
        >
          "I'm not here because I'm broken. I'm here because I learned to see patterns —
          in myself and everyone around me — and I want to share what I've found."
        </div>

        <p style={{ color: 'var(--yup-muted)', fontSize: '16px', lineHeight: 1.8, marginBottom: '20px' }}>
          I've recently been diagnosed with ADHD. It explained a lot. The intensity.
          The pattern recognition. The systems I built — not to help myself, but to
          contain myself. I spent 38 years playing small because being too loud got
          punished early.
        </p>
        <p style={{ color: 'var(--yup-muted)', fontSize: '16px', lineHeight: 1.8, marginBottom: '32px' }}>
          YUP exists for one reason: so my daughter sees a version of her dad that is
          complete on the inside. And maybe it helps you too.
        </p>
        <p
          className="font-serif"
          style={{
            fontSize: '20px',
            fontStyle: 'italic',
            color: 'var(--yup-ink)',
          }}
        >
          — Jason, Founder
        </p>
      </div>
    </section>
  );
};

export default JasonSection;
